import axios from '../axios';

export const getEventList = () => {
    return axios.get('/v1/event/list');
};

export const getEventInfo = async ({ eventId, info }) => {
    return axios.get('/v1/event/list/info', { eventId, info });
};
